import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper, Box, Container, CircularProgress, Backdrop } from '@mui/material';
import { AccountCircle, School, Group } from '@mui/icons-material';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../redux/userRelated/userHandle';
import Popup from '../components/Popup';

const ChooseUser = ({ visitor }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, currentUser, currentRole } = useSelector(state => state.user);

  const [loader, setLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");

  const navigateHandler = (user) => {
    const password = "zxc";
    if (user === "Admin") {
      if (visitor === "guest") {
        const email = "admin@example.com";
        const fields = { email, password };
        setLoader(true);
        dispatch(loginUser(fields, user));
      } else {
        navigate('/Adminlogin');
      }
    } else if (user === "Student") {
      if (visitor === "guest") {
        const rollNum = "1";
        const studentName = "John Doe";
        const fields = { rollNum, studentName, password };
        setLoader(true);
        dispatch(loginUser(fields, user));
      } else {
        navigate('/Studentlogin');
      }
    } else if (user === "Teacher") {
      if (visitor === "guest") {
        const email = "teacher@example.com";
        const fields = { email, password };
        setLoader(true);
        dispatch(loginUser(fields, user));
      } else {
        navigate('/Teacherlogin');
      }
    }
  };

  useEffect(() => {
    if (status === 'success' || currentUser !== null) {
      if (currentRole === 'Admin') {
        navigate('/Admin/dashboard');
      } else if (currentRole === 'Student') {
        navigate('/Student/dashboard');
      } else if (currentRole === 'Teacher') {
        navigate('/Teacher/dashboard');
      }
    } else if (status === 'error') {
      setLoader(false);
      setMessage("Network Error");
      setShowPopup(true);
    }
  }, [status, currentRole, navigate, currentUser]);

  return (
    <StyledContainer>
      <Container>
        <Grid container spacing={3} justifyContent="center">
          {['Admin', 'Student', 'Teacher'].map((role) => (
            <Grid item xs={12} sm={6} md={4} key={role}>
              <StyledCard onClick={() => navigateHandler(role)}>
                <IconWrapper>
                  {role === 'Admin' && <StyledAdminIcon fontSize="large" />}
                  {role === 'Student' && <StyledStudentIcon fontSize="large" />}
                  {role === 'Teacher' && <StyledTeacherIcon fontSize="large" />}
                </IconWrapper>
                <StyledTitle>{role}</StyledTitle>
                <StyledDescription>
                  {role === 'Admin' && 'Manage system settings and data'}
                  {role === 'Student' && 'Access courses, materials, and track progress'}
                  {role === 'Teacher' && 'Create content and manage classes'}
                </StyledDescription>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Backdrop sx={{ color: '#fff', zIndex: 10, background: 'rgba(20, 80, 80, 0.8)' }} open={loader}>
        <CircularProgress color="inherit" />
        Please Wait
      </Backdrop>
      <Popup message={message} setShowPopup={setShowPopup} showPopup={showPopup} />
    </StyledContainer>
  );
};

export default ChooseUser;

// Styled Components
const StyledContainer = styled.div`
  background: linear-gradient(135deg, #004d40 0%, #fdd835 100%);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

const StyledCard = styled(Paper)`
  padding: 2rem;
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(15px);
  border: 2px solid #fdd835;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 14px 50px rgba(253, 216, 53, 0.4);
  }
`;

const IconWrapper = styled(Box)`
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
`;

const iconStyles = `
  color: #fdd835;
  font-size: 4rem !important;
  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    transform: scale(1.2);
    color: #004d40;
  }
`;

const StyledAdminIcon = styled(AccountCircle)`${iconStyles}`;
const StyledStudentIcon = styled(School)`${iconStyles}`;
const StyledTeacherIcon = styled(Group)`${iconStyles}`;

const StyledTitle = styled.h2`
  color: #004d40;
  font-size: 1.8rem;
  font-weight: 700;
`;

const StyledDescription = styled.p`
  color: #444;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 300px;
`;
